import ErrorPayment from 'components/Patient/checkin/SecurePayment/ErrorPayment';

import { usePaymentContextApi } from '../context/PaymentContext';

const ErrorPaymentModal = ({
  message,
  description,
  title,
  isOpen = true,
  onClearError = () => {},
  onClose = () => {},
  onTryAgain
}) => {
  const { closeModal } = usePaymentContextApi();

  const handleClearError = () => {
    closeModal();
    onClearError(null);
    onClose();
  };

  const handleTryAgain = () => {
    onClearError(null);
    onTryAgain();
  };

  return (
    <ErrorPayment
      isOpen={isOpen}
      message={message}
      description={description}
      title={title}
      onTryAgain={onTryAgain ? handleTryAgain : handleClearError}
      onClose={handleClearError}
    />
  );
};

export default ErrorPaymentModal;
